import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template", "input"];

  connect() {
    let fields = [];
    try {
      fields = JSON.parse(this.inputTarget.value || "[]");
    } catch {
      fields = [];
    }
    fields.forEach((field) => this.add(field));
    this.updateEmptyState();
  }

  add(field = {}) {
    const fragment = this.templateTarget.content.cloneNode(true);
    const row = fragment.querySelector("[data-field-row]");
    row.dataset.key =
      field.key || `field_${this.listTarget.children.length + 1}`;
    row.querySelector("[data-field-name]").value = field.name || "";
    row.querySelector("[data-field-type]").value = field.type || "text";
    row.querySelector("[data-field-required]").checked = Boolean(
      field.required,
    );
    row.querySelector("[data-field-options]").value = (
      field.options || []
    ).join(", ");
    this.listTarget.appendChild(fragment);
    this.toggleOptions({
      target:
        this.listTarget.lastElementChild.querySelector("[data-field-type]"),
    });
    this.updateEmptyState();
  }

  remove(event) {
    event.currentTarget.closest("[data-field-row]").remove();
    this.updateEmptyState();
  }

  toggleOptions(event) {
    const row = event.target.closest("[data-field-row]");
    row.querySelector("[data-options-wrap]").hidden =
      event.target.value !== "select";
  }

  submit() {
    const fields = [
      ...this.listTarget.querySelectorAll("[data-field-row]"),
    ].map((row) => {
      const type = row.querySelector("[data-field-type]").value;
      const field = {
        key: row.dataset.key,
        name: row.querySelector("[data-field-name]").value.trim(),
        type,
        required: row.querySelector("[data-field-required]").checked,
      };
      if (type === "select")
        field.options = row
          .querySelector("[data-field-options]")
          .value.split(",")
          .map((v) => v.trim())
          .filter(Boolean);
      return field;
    });
    this.inputTarget.value = JSON.stringify(fields);
  }

  updateEmptyState() {
    const empty = this.element.querySelector("[data-empty-fields]");
    if (empty) empty.hidden = this.listTarget.children.length > 0;
  }
}
